import { SERVER_PATH } from '../endpoints'
import { ENDPOINT_URL } from '../../shared/data/dashboard-statistics'
import axios from 'axios'
import failedSession from '../failedSession'

export default async () => {
  const URL = SERVER_PATH + ENDPOINT_URL
  try {
    const { data } = await axios.get(URL, {
      withCredentials: true
    })
    return { data: data }
  } catch (e) {
    failedSession(e)
    return { error: 'unknown' }
  }
}
